import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

export default function ProfileOverviewCard({ volunteer }) {
  const navigate = useNavigate();

  const fields = [
    { icon: 'Mail', label: 'Email', value: volunteer?.email },
    { icon: 'Phone', label: 'Mobile', value: volunteer?.mobile },
    { icon: 'GraduationCap', label: 'School / College', value: volunteer?.school },
    { icon: 'Cake', label: 'Date of Birth', value: volunteer?.dob },
  ];

  return (
    <div className="bg-card border border-border rounded-xl p-5 md:p-6 shadow-sm">
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-base md:text-lg font-heading font-semibold text-foreground flex items-center gap-2">
          <Icon name="User" size={18} color="var(--color-primary)" />
          Profile Overview
        </h2>
        <Button
          variant="outline"
          size="sm"
          iconName="Pencil"
          iconPosition="left"
          iconSize={14}
          onClick={() => navigate('/editable-profile-screen')}
        >
          Edit Profile
        </Button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {fields?.map((field) => (
          <div key={field?.label} className="flex items-start gap-3">
            <div className="w-8 h-8 rounded-md bg-muted flex items-center justify-center flex-shrink-0 mt-0.5">
              <Icon name={field?.icon} size={15} color="var(--color-primary)" />
            </div>
            <div className="min-w-0">
              <p className="text-xs font-caption text-muted-foreground">{field?.label}</p>
              <p className="text-sm font-caption font-medium text-foreground truncate">{field?.value || '—'}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}